/* VIA — motion homepage (GSAP + ScrollTrigger + Lenis). Falls back to a static page if they fail to load. */
(function () {
  var root = document.documentElement;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function off() {
    root.classList.remove('vm-js');
  }
  if (!window.gsap || !window.ScrollTrigger || reduce) {
    off();
    bindStatic();
    return;
  }
  root.classList.add('vm-ready');
  var gsap = window.gsap;
  var ST = window.ScrollTrigger;
  gsap.registerPlugin(ST);

  /* smooth scroll (drawers, menus and modals keep native scrolling) */
  var lenis = null;
  if (window.Lenis) {
    lenis = new window.Lenis({
      lerp: 0.09,
      prevent: function (node) {
        return !!(node.closest && node.closest('cart-drawer, .drawer, .menu-drawer, .search-modal, details[open], [data-lenis-prevent]'));
      },
    });
    lenis.on('scroll', ST.update);
    gsap.ticker.add(function (t) {
      lenis.raf(t * 1000);
    });
    gsap.ticker.lagSmoothing(0);
    var stop = function () {
      lenis.stop();
    };
    var start = function () {
      lenis.start();
    };
    new MutationObserver(function () {
      document.body.classList.contains('overflow-hidden') || document.body.classList.contains('overflow-hidden-mobile') ? stop() : start();
    }).observe(document.body, { attributes: true, attributeFilter: ['class'] });
  }

  /* split headings into words */
  document.querySelectorAll('[data-vm-split]').forEach(function (h) {
    (function walk(n) {
      Array.prototype.slice.call(n.childNodes).forEach(function (c) {
        if (c.nodeType === 3) {
          var f = document.createDocumentFragment();
          c.textContent.split(/(\s+)/).forEach(function (w) {
            if (!w) return;
            if (/^\s+$/.test(w)) return f.appendChild(document.createTextNode(w));
            var o = document.createElement('span');
            o.className = 'vm-word';
            var i = document.createElement('span');
            i.textContent = w;
            o.appendChild(i);
            f.appendChild(o);
          });
          c.replaceWith(f);
        } else if (c.nodeType === 1) walk(c);
      });
    })(h);
  });

  /* hero: fly through the giant word */
  var hero = document.querySelector('[data-vm-hero]');
  if (hero) {
    var small = window.matchMedia('(max-width: 700px)').matches;
    var tl = gsap.timeline({
      scrollTrigger: {
        trigger: hero,
        start: 'top top',
        end: '+=170%',
        scrub: 1,
        pin: true,
        onUpdate: function (s) {
          document.body.classList.toggle('vm-hero-light', s.progress > 0.8);
        },
      },
    });
    tl.to(hero.querySelector('.vm-hero__mask'), { scale: small ? 14 : 22, transformOrigin: '49.4% 50%', ease: 'power2.in', duration: 1 })
      .to(hero.querySelector('.vm-hero__mask'), { opacity: 0, duration: 0.15 }, '-=0.12')
      .to(hero.querySelector('.vm-hero__img'), { scale: 1, duration: 1.15, ease: 'none' }, 0)
      .to(hero.querySelectorAll('.vm-hero__tag, .vm-hero__hint'), { opacity: 0, duration: 0.2 }, 0)
      .to(hero.querySelector('.vm-hero__shade'), { opacity: 1, duration: 0.3 }, 0.8)
      .to(hero.querySelectorAll('.vm-hero__c, .vm-hero__meta'), { opacity: 1, duration: 0.25 }, 0.95)
      .from(hero.querySelectorAll('.vm-hero__c .vm-word > span'), { yPercent: 110, stagger: 0.03, duration: 0.3 }, 0.95)
      .from(hero.querySelectorAll('.vm-hero__c p, .vm-hero__c .vm-ctas'), { y: 30, opacity: 0, stagger: 0.05, duration: 0.25 }, 1.05)
      .from(hero.querySelectorAll('.vm-chip'), { x: 40, opacity: 0, stagger: 0.06, duration: 0.25 }, 1.05);
    gsap.from(hero.querySelector('.vm-hero__mask span'), { yPercent: 30, opacity: 0, duration: 1.2, ease: 'power4.out', delay: 0.2 });
  }

  /* marquee rows drift with the scroll */
  document.querySelectorAll('[data-vm-mq]').forEach(function (r) {
    var d = +r.getAttribute('data-vm-mq');
    gsap.fromTo(
      r,
      { xPercent: d < 0 ? 0 : -30 },
      { xPercent: d < 0 ? -30 : 0, ease: 'none', scrollTrigger: { trigger: r.closest('.vm-mq'), start: 'top bottom', end: 'bottom top', scrub: 0.6 } }
    );
  });

  /* counters */
  document.querySelectorAll('[data-vm-count]').forEach(function (el) {
    var o = { v: 0 };
    gsap.to(o, {
      v: +el.getAttribute('data-vm-count'),
      duration: 2,
      ease: 'power2.out',
      scrollTrigger: { trigger: el, start: 'top 88%' },
      onUpdate: function () {
        el.textContent = Math.round(o.v);
      },
    });
  });

  /* headings + blocks reveal */
  document.querySelectorAll('[data-vm-split]').forEach(function (h) {
    if (h.closest('[data-vm-hero]')) return;
    gsap.from(h.querySelectorAll('.vm-word > span'), { yPercent: 110, duration: 1, stagger: 0.05, ease: 'power4.out', scrollTrigger: { trigger: h, start: 'top 85%' } });
  });
  gsap.utils.toArray('[data-vm-fade]').forEach(function (e) {
    gsap.from(e, { y: 40, opacity: 0, duration: 1, ease: 'power3.out', scrollTrigger: { trigger: e, start: 'top 88%' } });
  });
  gsap.utils.toArray('[data-vm-reveal]').forEach(function (e) {
    gsap.from(e, { clipPath: 'inset(18% 10% 18% 10% round 36px)', duration: 1.4, ease: 'power4.out', scrollTrigger: { trigger: e, start: 'top 80%' } });
  });

  /* arch photo */
  document.querySelectorAll('.vm-arch').forEach(function (a) {
    gsap.to(a, { clipPath: 'inset(0% 0 0 0 round 999px 999px 28px 28px)', duration: 1.6, ease: 'power4.inOut', scrollTrigger: { trigger: a, start: 'top 80%' } });
    gsap.to(a.querySelector('img'), { scale: 1, ease: 'none', scrollTrigger: { trigger: a, start: 'top bottom', end: 'bottom top', scrub: true } });
  });

  /* categories: horizontal scroll on desktop */
  ST.matchMedia({
    '(min-width: 990px)': function () {
      document.querySelectorAll('[data-vm-hz]').forEach(function (sec) {
        var track = sec.querySelector('.vm-hz__track');
        var bar = sec.querySelector('.vm-hz__bar i');
        var num = sec.querySelector('[data-vm-hz-n]');
        var n = track.children.length;
        var dist = function () {
          return Math.max(0, track.scrollWidth - window.innerWidth);
        };
        gsap.to(track, {
          x: function () {
            return -dist();
          },
          ease: 'none',
          scrollTrigger: {
            trigger: sec,
            start: 'top top',
            end: function () {
              return '+=' + dist();
            },
            pin: true,
            scrub: 1,
            invalidateOnRefresh: true,
            onUpdate: function (s) {
              if (bar) bar.style.transform = 'scaleX(' + s.progress + ')';
              if (num) num.textContent = ('0' + Math.min(n, 1 + Math.floor(s.progress * n))).slice(-2);
            },
          },
        });
      });
    },
  });

  /* steps: light up one by one and swap the sticky visual */
  document.querySelectorAll('[data-vm-steps]').forEach(function (sec) {
    var steps = sec.querySelectorAll('.vm-step');
    var vis = sec.querySelectorAll('.vm-vis');
    steps.forEach(function (s, i) {
      ST.create({
        trigger: s,
        start: 'top 60%',
        end: 'bottom 60%',
        onToggle: function (e) {
          if (!e.isActive) return;
          steps.forEach(function (x, j) {
            x.classList.toggle('is-on', j === i);
          });
          vis.forEach(function (v, j) {
            v.classList.toggle('is-on', j === i);
          });
        },
      });
    });
  });

  /* offer glow follows the pointer */
  document.querySelectorAll('.vm-offer').forEach(function (o) {
    var g = o.querySelector('.vm-glow');
    o.addEventListener('mousemove', function (e) {
      var r = o.getBoundingClientRect();
      gsap.to(g, { x: e.clientX - r.right + r.width * 0.3, y: e.clientY - r.top - r.height * 0.4, duration: 1.2, ease: 'power3.out' });
    });
  });

  /* giant footer word rises */
  document.querySelectorAll('.vm-fword').forEach(function (w) {
    gsap.from(w, { yPercent: 30, opacity: 0, ease: 'none', scrollTrigger: { trigger: w, start: 'top bottom', end: 'bottom bottom', scrub: true } });
  });

  window.addEventListener('load', function () {
    ST.refresh();
  });
  bindStatic();

  /* things that work with or without motion: tabs, copy code, quick add */
  function bindStatic() {
    document.querySelectorAll('[data-vm-tabs]').forEach(function (wrap) {
      var btns = wrap.querySelectorAll('[role="tab"]');
      btns.forEach(function (b) {
        b.addEventListener('click', function () {
          btns.forEach(function (x) {
            var on = x === b;
            x.setAttribute('aria-selected', on);
            var p = document.getElementById(x.getAttribute('aria-controls'));
            if (p) p.hidden = !on;
          });
          if (window.ScrollTrigger) window.ScrollTrigger.refresh();
        });
      });
    });
    document.querySelectorAll('[data-vm-copy]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (navigator.clipboard) navigator.clipboard.writeText(b.getAttribute('data-vm-copy')).catch(function () {});
        var t = b.querySelector('span');
        if (t) t.textContent = b.getAttribute('data-done');
      });
    });
    document.querySelectorAll('form[data-vm-add]').forEach(function (f) {
      f.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = f.querySelector('button');
        var drawer = document.querySelector('cart-drawer');
        var fd = new FormData(f);
        if (drawer && drawer.getSectionsToRender) {
          fd.append(
            'sections',
            drawer.getSectionsToRender().map(function (s) {
              return s.id;
            })
          );
          fd.append('sections_url', window.location.pathname);
        }
        fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
          body: fd,
        })
          .then(function (r) {
            return r.json();
          })
          .then(function (res) {
            if (res.status) {
              window.location.href = f.getAttribute('data-url');
              return;
            }
            btn.classList.add('is-done');
            var t = btn.querySelector('span');
            if (t) t.textContent = btn.getAttribute('data-done');
            if (drawer && drawer.renderContents) {
              drawer.classList.remove('is-empty');
              drawer.renderContents(res);
            }
          })
          .catch(function () {
            f.submit();
          });
      });
    });
  }
})();
